// GLOBAL

jQuery(document).ready(function ($) {
   
   //FANCY BOX
   $.fn.fancybox_images = function (params) {
      this.each(function () {
         $("a[href$='.jpg'], a[href$='.png'], a[href$='.jpeg'], a[href$='.gif'], a[href$='.svg']").fancybox({
            keyboard: true,
            loop: false,
            arrows: true,
            infobar: false,
            afterLoad: function (instance, current) {
               var pixelRatio = window.devicePixelRatio || 1;
               
               if (pixelRatio > 1.5) {
                  current.width = current.width / pixelRatio;
                  current.height = current.height / pixelRatio;
               }
            }
         });
      });
   };
   $('body').fancybox_images();
   
   
   //PARALLAX
    if( $(".rellax").length ) {
        if (!/Android|iPhone/i.test(navigator.userAgent)) {
            var rellax = new Rellax('.rellax', {
                center: true
            });
        }
    }
   
   $(document).scroll(function () {
      if ($(document).scrollTop() >= 70) {
         $("#header,nav.mobile").addClass("stick")
      } else {
         $("#header,nav.mobile").removeClass("stick")
      }
   });


   //SMOOTH SCROLL
   $('a[href^="#"]').on('click', function (event) {
      event.preventDefault();
      var target = this.hash;
      $('html, body').animate({scrollTop: $(target).offset().top - 20}, 800);
   });

   //nav mobile foldable
   $('nav.mobile .menu-item-has-children > a').on('click', function (e) {
      e.preventDefault();
      $(this).next("ul").slideToggle();
      $(this).toggleClass("open");
   });
});


